import axios from "axios"
import { useState } from "react"
import { set } from "react-hook-form"

const useLazyQuery = <Type>():[fetchData: (url: string) => Promise<void>, response:{isLoading: boolean, data: Type | null, error: any}] => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [data, setData] = useState<Type | null>(null)
    const [error, setError] = useState<any | null>(null)

    const fetchData = async(url: string)=>{
        try {
            setIsLoading(true)
            const promise = await axios.get<Type>(url)
            const data = promise.data
            setData(data)
            setError(null)
            setIsLoading(false)
        } catch (error) {
            setError(error)
            setIsLoading(false)
        }
    }
    return [fetchData,{isLoading,data,error}]
}

export default useLazyQuery